import * as Immutable from 'immutable';
import UserSecurityStore from '../_stores/UserSecurityStore';
import { AccountAction, AccountActionType } from '../_actions/UserAccountActions';

const UserSecurityReducer = (store:UserSecurityStore = new UserSecurityStore(), action: AccountAction):UserSecurityStore => {
	switch (action.type) {
		case AccountActionType.EditUserSecurity:
			let {email} = action.updates;
			store = store.withMutations((store) => {
				store = store.set('email', email);
			});
	}
	return store;
}
export default UserSecurityReducer